import { createFileRoute, redirect } from "@tanstack/react-router"
import * as z from "zod"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { pick } from "@repo/utils/collections"
import { sharedConfig } from "~/lib/config/shared"
import { isAbsoluteUrl } from "~/lib/utils/http"
import { AuthLayout } from "~/modules/auth/components/auth-layout"
import { SignInForm } from "./sign-in-form"

const searchSchema = z.looseObject({
  next: z
    .string()
    .optional()
    .refine(
      // We do not want to redirect to absolute URLs (like //evil.com/foo)
      (v) => v === undefined || v === "" || !isAbsoluteUrl(v),
      "Invalid next",
    )
    .catch(""),
})

export const Route = createFileRoute("/_auth-layout/auth/sign-in")({
  component: SignInScreen,
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => pick(search, ["next"]),
  beforeLoad: ({ context }) => {
    if (context.user) {
      throw redirect({
        to: "/",
      })
    }
  },
  head: ({ match }) => ({
    meta: generateMetaTags({
      robots: ["noindex", "nofollow", "noarchive"],
      base: {
        title: `Sign In | ${sharedConfig.appName}`,
        description: `Sign in to ${sharedConfig.appName}`,
        url: new URL(match.fullPath, sharedConfig.baseUrl).toString(),
      },
    }),
  }),
})

function SignInScreen() {
  const { next } = Route.useSearch()

  return (
    <AuthLayout title="Sign In">
      <SignInForm next={next} />
    </AuthLayout>
  )
}
